function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#sm)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M87.7079 268.533L27.2079 202.365L-94.5201 378.627L-231.362 415.427L-224.897 517.327L-196.762 494.183C23.3989 544.274 87.7079 268.533 87.7079 268.533Z",
  fill: "#D4775E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-5.34308 440.275C9.07692 388.767 0.756927 342.335 -29.1431 327.012C-37.2937 322.94 -46.4254 321.242 -55.4951 322.112L-94.5241 378.625L-148.824 393.225C-152.656 399.255 -156.295 405.589 -159.688 412.211C-174.605 441.311 -182.393 471.025 -183.257 496.875C-104.641 510.42 -46.8551 481.58 -5.34308 440.275Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.2319 235.775C81.2319 235.775 -21.4201 470.384 -115.986 557.905L-113.956 574.199L-183.966 538.313C-183.966 538.313 -43.3131 245.07 -11.3041 182.623L81.2319 235.775Z",
  fill: "#FA7F58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.482 35.169L141.057 68.091L98.9259 72.629L106.393 17.069L148.525 12.526L145.482 35.169Z",
  fill: "#F9D6CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.059 43.4679C121.666 43.4679 122.159 42.9755 122.159 42.3679C122.159 41.7604 121.666 41.2679 121.059 41.2679C120.451 41.2679 119.959 41.7604 119.959 42.3679C119.959 42.9755 120.451 43.4679 121.059 43.4679Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.808 45.719C138.415 45.719 138.908 45.2266 138.908 44.619C138.908 44.0115 138.415 43.519 137.808 43.519C137.2 43.519 136.708 44.0115 136.708 44.619C136.708 45.2266 137.2 45.719 137.808 45.719Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.021 50.462L134.279 33.662L142.698 34.793",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.389 31.792L128.808 32.923",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.224 38.654L105.44 44.49C104.691 44.3894 103.97 44.1424 103.317 43.763C102.664 43.3836 102.092 42.8793 101.634 42.2789C101.175 41.6785 100.84 40.9937 100.647 40.2636C100.453 39.5336 100.405 38.7725 100.506 38.024C100.529 37.849 100.56 37.677 100.599 37.508C101.397 34.012 106.705 35.101 106.224 38.654Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.443 44.4899C104.694 44.3894 103.973 44.1423 103.32 43.763C102.667 43.3836 102.095 42.8793 101.637 42.2789C101.179 41.6784 100.843 40.9936 100.65 40.2636C100.456 39.5335 100.408 38.7725 100.509 38.0239",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.784 54.111C126.254 53.9054 124.868 53.1005 123.932 51.8733C122.995 50.646 122.584 49.097 122.79 47.567",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.058 68.0859L98.9259 72.6289",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.019 50.4771L128.215 50.8871",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.6849 102.655L-11.3041 182.622L87.7069 268.528L133.358 179.467C141.224 164.122 143.717 146.582 140.44 129.652C137.163 112.723 128.303 97.3811 115.279 86.08C108.935 80.5755 101.422 76.5859 93.3094 74.4127C85.1963 72.2395 76.6953 71.9398 68.4494 73.5362C60.2034 75.1327 52.4285 78.5834 45.7127 83.6274C38.9969 88.6714 33.5161 95.1767 29.6849 102.651V102.655Z",
  fill: "#C6E647"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.2359 235.775C81.2359 235.775 -21.4171 470.383 -115.986 557.905",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.847 35.962C107.847 35.962 113.316 34.092 116.132 20.903C116.132 20.903 142.789 38.053 149.06 22.458",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.657 35.264L102.274 8.99501C102.274 8.99501 143.897 0.695006 153.979 15.944C153.979 15.944 155.331 25.612 145.851 32.412",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.8759 73.439C67.8759 73.439 -11.6791 99.639 -24.3971 179.439C-37.1151 259.239 130.37 250.651 144.636 204.263C144.636 204.263 161.422 197.117 155.117 195.442C148.812 193.767 28.5089 182.173 28.5089 182.173L66.2849 148.033",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.849 82.792C111.849 82.792 149.149 114.364 157.808 169.807C157.808 169.807 192.685 106.598 201.476 106.701C210.267 106.804 230.976 104.978 225.746 110.089C220.516 115.2 209.636 116.624 209.636 116.624C209.636 116.624 220.363 128.124 204.277 132.595C204.277 132.595 206.526 245.706 136.517 241.358C127.057 240.647 117.656 239.3 108.378 237.326",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "sm"
}, /*#__PURE__*/React.createElement("rect", {
  width: 234.408,
  height: 445.659,
  fill: "white"
})));

var SvgSponsorMan = function SvgSponsorMan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 446,
    viewBox: "0 0 235 446",
    fill: "none",
    className: "hidden md:block absolute top-0 left-0 mt-80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSponsorMan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SponsorMan.62665e29.svg";
export { ForwardRef as ReactComponent };